import { Controller } from "@hotwired/stimulus"
import { createIcons, icons } from 'lucide'

export default class extends Controller {
  static targets = ["overlay", "title", "message", "confirmBtn", "cancelBtn", "confirmState", "loadingState"]
  static values = {
    title: { type: String, default: "Confirm Action" },
    message: { type: String, default: "Are you sure?" },
    confirmUrl: String,
    confirmMethod: { type: String, default: "post" }
  }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    event.preventDefault()

    const trigger = event.currentTarget
    this.confirmUrlValue = trigger.dataset.confirmUrl || trigger.href
    this.confirmMethodValue = trigger.dataset.confirmMethod || "post"
    this.titleValue = trigger.dataset.confirmTitle || "Confirm Action"
    this.messageValue = trigger.dataset.confirmMessage || "Are you sure?"

    if (this.hasTitleTarget) this.titleTarget.textContent = this.titleValue
    if (this.hasMessageTarget) this.messageTarget.textContent = this.messageValue

    // Reset to confirm state
    this.showConfirmState()

    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.handleKeydown)
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.handleKeydown)
    // Reset state for next open
    this.showConfirmState()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  showConfirmState() {
    this.isLoading = false
    if (this.hasConfirmStateTarget) this.confirmStateTarget.classList.remove("hidden")
    if (this.hasLoadingStateTarget) this.loadingStateTarget.classList.add("hidden")
  }

  showLoadingState() {
    this.isLoading = true
    if (this.hasConfirmStateTarget) this.confirmStateTarget.classList.add("hidden")
    if (this.hasLoadingStateTarget) this.loadingStateTarget.classList.remove("hidden")
    // Refresh Lucide icons for the coffee icon
    setTimeout(() => createIcons({ icons }), 0)
  }

  async confirm() {
    // Show loading state with coffee
    this.showLoadingState()

    try {
      const response = await fetch(this.confirmUrlValue, {
        method: this.confirmMethodValue.toUpperCase(),
        headers: {
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      if (response.ok) {
        // Job was queued successfully - keep modal open showing coffee
        // User can close it and the page will reload when job completes
      } else {
        // Show error and reset
        this.showConfirmState()
        if (this.hasMessageTarget) this.messageTarget.textContent = "Something went wrong. Please try again."
      }
    } catch (err) {
      console.error("Confirm action failed:", err)
      this.showConfirmState()
      if (this.hasMessageTarget) this.messageTarget.textContent = "Something went wrong. Please try again."
    }
  }

}
